<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h2>Attachment Dialog</h2>
        <form v-on:submit.prevent="handleSubmit">
          <div class="formContentSc">
            <div class="formContent" v-for="(c, i) in contents" :key="i">
              <div class="fieldGroup">
                <div class="fieldCnt">
                  <label>Title</label>
                  <input type="text" class="field" placeholder="Dialog title..."
                    v-model="c.title">
                </div>
              </div>
              <div class="fieldGroup">
                <label>Content</label>
                <Editor v-model="c.content" :content="c.contentTmp" size="small"></Editor>
              </div>
            </div>
          </div>
          <div class="btnCnt">
            <div class="btn btnSecondary add" v-on:click="addMoreContent"
              v-if="!saving">
              Add more content</div>
            <button class="btn btnSecondary btnLg" type="button"
              v-on:click="close(false)" v-if="!saving">
              Cancel
            </button>
            <button class="btn btnPrimary btnLg" v-if="id && !saving">
              Save Changes
            </button>
            <button class="btn btnPrimary btnLg" v-if="!id && !saving">
              Add Attachment
            </button>
            <button class="btn btnPrimary btnLg saving" type="button" v-if="saving">
              Saving...
            </button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import Editor from '@/components/Editor.vue';

export default {
  components: {
    Editor,
  },
  data() {
    return {
      loading: false,
      show: false,
      description: '',
      saving: false,
      id: null,
      contents: [{ title: '', content: '', contentTmp: '' }],
    };
  },
  methods: {
    open(d, n) {
      this.next = n;
      this.show = true;
      this.saving = false;
      this.contents = [];
      if (d && d.contents) {
        // eslint-disable-next-line
        for (const c of d.contents) {
          this.contents.push({ title: c.title, content: c.content, contentTmp: '' });
        }
      }
      if (this.contents.length < 1) {
        this.contents.push({ title: '', content: '', contentTmp: '' });
      }
      setTimeout(() => {
        // eslint-disable-next-line
        for (const c of this.contents) {
          // eslint-disable-next-line
          c.contentTmp = c.content;
        }
      });
    },
    addMoreContent() {
      this.contents.push({ title: '', contentTmp: '', content: '' });
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, this.contents);
    },
    handleSubmit() {
      // eslint-disable-next-line
      for (const c of this.contents) {
        // eslint-disable-next-line
        c.contentTmp = '';
      }
      this.close(true);
    },
  },
};
</script>

<style scoped lang="scss">
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;

  .fieldCnt.hasError{
    .field{
      border-color: red;
    }
    .fieldError{
      display: block;
    }
  }
  .fieldCnt.hasPrefix{
    position: relative;
    .field{
      padding-left: 40px;
    }
    .fieldPrefix{
      position: absolute;
      left: 10px; top: 35px;
      z-index: 3;
      color: #767676;
    }
  }

  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    margin: auto;
    border-radius: 5px;
    padding: 40px 100px;
    overflow: hidden;
    transition: all .3s ease;
    width: 760px;
    box-sizing: border-box;
    padding: 40px 80px;
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading-2.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
      &:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
    }
    h2{
      font-size: 24px;
      font-weight: 600;
      margin: 0 0 10px;
    }
    .formContentSc{
      border-top: #eee 1px solid;
      max-height: 64vh;
      box-sizing: border-box;
      overflow: auto;
      margin: 0 -80px;
    }
    .formContent{
      box-sizing: border-box;
      padding: 10px 80px 0;
      border-bottom: #eee 1px solid;
      &:last-child{
        border-bottom: none;
      }
    }
    .fieldGroupBos{
      display: flex;
      .fieldCnt{
        width: 100%;
      }
      .recomended{
        padding: 34px 0 0 30px;
        margin-left: auto;
        display: flex;
        label{
          display: block;
          margin: 0;
          margin-right: 14px;
          padding-top: 3px;
        }
        .toggle{
          background-color: #e5e5e5;
          border-radius: 50px;
          width: 40px;
          height: 26px;
          position: relative;
          cursor: pointer;
          &:hover{
            background-color: #ddd;
          }
          &:before{
            content: "";
            display: block;
            position: absolute;
            left: 3px; top: 3px;
            background-color: #fff;
            width: 20px; height: 20px;
            border-radius: 50%;
            transition: all .2s ease;
          }
          &.on{
            background-color: #0067ff;
            &:before{
              left: 16px;
            }
          }
        }
      }
    }
    .fieldGroup2{
      .fieldCnt{
        float: left;
        width: calc(50% - 10px);
      }
      .fieldCnt.fieldCnt1{
        margin-right: 20px;
      }
    }
    .logoCnt{
      padding-left: 90px;
      height: 70px;
      position: relative;
      padding-top: 18px;
      box-sizing: border-box;
      .logo{
        border: #eee 1px solid;
        width: 70px;
        height: 70px;
        border-radius: 5px;
        position: absolute;
        left: 0; top: 0;
        cursor: pointer;
        background-color: #eee;
        font-weight: bold;
        font-size: 20px;
        color: #bbb;
        text-align: center;
        padding-top: 20px;
        box-sizing: border-box;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        &.logoProfile{
          border-radius: 50%;
          background-size: cover;
        }
        &.hasLogo{
          background-color: #fff;
          span{
            display: none;
          }
        }
        &:hover{
          border-color: #ddd;
        }
      }
      .addLogo{
        border: #0057d8 1px solid;
        border-radius: 4px;
        background-color: #fff;
        color: #0057d8;
        padding: 8px 12px;
        cursor: pointer;
        &:hover{
          box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        }
      }
    }
    .btnCnt{
      text-align: right;
      border-top: #eee 1px solid;
      margin: 0 -80px -40px;
      padding: 12px 30px 2px;
      display: flex;
      align-items: center;
      .btn.add{
        margin-right: auto;
      }
    }
    .btn{
      margin-left: 5px;
      margin-bottom: 10px;
      &.saving{
        background-color: #ccc;
        color: #999;
        cursor: default;
        box-shadow: none;
      }
    }
  }
}
</style>
